<template>
  <div class="header-wrapper">
    <div
      @click="toggleSideMenu"
      :class="['nav-icon', { 'nav-icon-opened': expandNav }]"
    >
      <span /><span /><span />
    </div>
    <a href="/dashboard"><div class="nav-logo" /></a>
    <user-menu />
  </div>
</template>
<script>
import UserMenu from './UserMenu';

export default {
  name: 'HeaderMenu',
  components: {
    UserMenu,
  },
  props: {
    expandNav: {
      type: Boolean,
    },
  },
  methods: {
    toggleSideMenu() {
      this.$emit('toggle-sidebar', !this.expandNav);
    },
  },
};
</script>
<style scoped>
.header-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  min-width: 280px;
  height: 50px;
  background-color: #333740;
  z-index: 3;
  border-bottom: 1px solid #1f1f1f;
}

.nav-logo {
  position: absolute;
  top: 13.5px;
  left: 30px;
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  width: 160px;
  height: 23px;
  background-image: url(~@/assets/img/logo_header.png);
}

.nav-icon {
  width: 30px;
  height: 24px;
  position: absolute;
  top: 19px;
  left: 30px;
  transform: rotate(0deg);
  cursor: pointer;
  display: none;
}

.nav-icon span {
  display: block;
  position: absolute;
  height: 16%;
  width: 100%;
  background: #eee;
  border-radius: 5.4px;
  opacity: 1;
  left: 0;
  transform: rotate(0deg);
  transition: 0.2s ease-in-out;
}

.nav-icon span:nth-child(1) {
  top: 0;
}

.nav-icon span:nth-child(2) {
  top: 42.5%;
}

.nav-icon span:nth-child(3) {
  top: 85%;
}

.nav-icon-opened span:nth-child(1) {
  top: 26%;
  width: 50%;
  transform: rotate(145deg);
}

.nav-icon-opened span:nth-child(3) {
  top: 60%;
  width: 50%;
  transform: rotate(-145deg);
}

@media screen and (max-width: 799px) {
  .header-wrapper {
    height: 50px;
  }

  .nav-logo {
    width: 125px;
    height: 28px;
    top: 11px;
    left: calc(50% - 60px);
  }

  .nav-icon {
    display: block;
    top: 15px;
    left: 15px;
    width: 27px;
    height: 21px;
  }
}
</style>
